module.exports = __webpack_public_path__ + "media/images/icons/twotone/info-circle-63c846b0c527417b7d57116ab041d501.svg";